<template>
  <div>
    <div class="mb-3">
      <filter-manager
        ref="filterRef"
        v-model="model.search.filters"
        class="search-bar"
        :display-advanced="false"
        :filters="filterManagerConfig"
        items-container-class="teachersForStudentsFilter"
        search-container-class="butn-process"
        search-icon="fas fa-search"
        search-text="Buscar"
        @search="onHandlerSearch"
        @type="getDisciplines"
      />
    </div>
    <icon-view
      class="my-3 icon-view-color-text"
      icon="far fa-history color-orange p-5"
      icon-size="1.5rem"
      title="Disciplinas"
      variant="icon-view-extended"
    />
    <callout
      v-for="(discipline, index) in model.disciplines"
      :key="discipline.disciplineId"
      border-color="#f7f7f7"
      class="mb-2 callout-extended"
      controlled
      :has-gradient="false"
      has-toggle
      :opened="discipline.opened"
      @click:open="open(discipline, index)"
    >
      <div class="py-1">
        <div class="d-inline mr-2">
          <i class="fad fa-folder-open text-orange fa-lg-custom" />
        </div>
        <span class="color-gray-7 font-16 font-weight-bold">
          {{ discipline.disciplineDesc | empty }}
        </span>
      </div>
      <template #edition>
        <div class="p-2 bg-gray">
          <div class="py-3 px-2 bg-white">
            <callout
              v-for="(item, idx) in discipline.items"
              :key="idx"
              border-color="#B5C3BC"
              :class="{ 'mt-3': idx > 0 }"
              controlled
              :has-toggle="true"
              :opened="item.opened"
              @click:open="openDoc(item, index, idx)"
            >
              <div class="row pt-1">
                <div class="col-12 col-md-4">
                  <div class="data-title">Tipo de Evaluación:</div>
                  <p class="info-text">
                    {{ item.evaluationTypeDesc | empty }}
                  </p>
                </div>
                <div class="col-12 col-md">
                  <div class="data-title">Fecha de la Evaluación:</div>
                  <p class="info-text">
                    {{ item.evaluationDate | date }}
                    {{ item.evaluationDate | hour }}
                  </p>
                </div>
                <div
                  class="col-12 col-md-2 px-0 mt-2 mt-md-0 d-md-flex justify-content-center"
                >
                  <div class="align-self-center">
                    <action-button
                      i="fas fa-file-download"
                      text="Descargar"
                      variant="outline-success"
                      @click="download(item)"
                    />
                  </div>
                </div>
              </div>
              <template #edition>
                <div class="p-2 bg-gray">
                  <div class="p-3 bg-white">
                    <div class="col-md-12 bg-white rounded py-4">
                      <span class="w-100 pl-1 dark-gray font-weight-bolder">
                        <em class="fa fa-info-circle text-orange" />
                        Información General de la Cita
                      </span>

                      <div class="row mx-0 mt-4 px-2 mb-3">
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Estatus de Cita:"
                            label-class="text-gray font-weight-light"
                            :value="model.detail?.appoitmentStatus"
                          />
                        </div>
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Número de Cita:"
                            label-class="text-gray font-weight-light"
                            :value="
                              $options.filters.appointmentFormat(
                                model.detail?.appoitmentNumber?.toString()
                              )
                            "
                          />
                        </div>
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="CSEE:"
                            label-class="text-gray font-weight-light"
                            :value="model.detail?.center"
                          />
                        </div>
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0  d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Teléfono de Proveedor:"
                            label-class="text-gray font-weight-light"
                            :value="
                              $options.filters.phone(
                                model.detail?.providerPhone
                              )
                            "
                          />
                        </div>
                      </div>
                      <div class="row mx-0 mt-4 px-2">
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Lugar:"
                            label-class="text-gray font-weight-light"
                            :value="model.detail?.location"
                          />
                        </div>
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Especialista:"
                            label-class="text-gray font-weight-light"
                            :value="model.detail?.specialist"
                          />
                        </div>
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0 d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Corporación:"
                            label-class="text-gray font-weight-light"
                            :value="model.detail?.company"
                          />
                        </div>
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0  d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Nombre de la Persona Contacto:"
                            label-class="text-gray font-weight-light"
                            :value="model.detail?.contact"
                          />
                        </div>
                      </div>
                      <div class="row mx-0 mt-4 px-2">
                        <div
                          class="col-6 col-md-3 mb-2 mb-md-0  d-flex flex-column"
                        >
                          <CustomInputDisplay
                            class="font-weight-bold"
                            label="Dirección Física:"
                            label-class="text-gray font-weight-light"
                            :value="model.detail?.address"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </callout>
          </div>
        </div>
      </template>
    </callout>
  </div>
</template>
<script>
import FilterManager from 'FilterManager';
import IconView from 'icon-view';
import Callout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomInputDisplay from 'CustomInputDisplay';

import {
  getRecordEvaluationFilterOptions,
  getRecordEvaluation,
  getRecordEvaluationDetail,
} from '@/modules/shared/studentreferral.api';
import DocumentsService from '@/modules/app/api';
import { getAllDisciplineTypes } from '@/modules/shared/code.api';

export default {
  name: 'RecordEvaluations',
  components: {
    FilterManager,
    IconView,
    Callout,
    ActionButton,
    CustomInputDisplay,
  },
  props: {
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      model: {
        search: {
          filters: {
            academicYear: null,
            type: null,
            therapy: null,
          },
          collections: {
            academicYears: [],
            types: [],
            therapies: [],
          },
        },
        disciplines: [],
        detail: {},
      },
    };
  },
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          class: 'col-12 col-lg-4',
          clearable: true,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
        },
        {
          name: 'type',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Tipo de Evaluación',
          class: 'col-12 col-lg-4',
          clearable: true,
          options: this.model.search.collections.types,
          value: this.model.search.filters.type,
          disabled: this.model.search.collections.types.length == 1,
        },
        {
          name: 'therapy',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Disciplina',
          class: 'col-12 col-lg-4',
          clearable: true,
          options: this.model.search.collections.therapies,
          value: this.model.search.filters.therapy,
          disabled: this.model.search.collections.therapies.length == 1,
        },
      ];
    },
  },
  watch: {
    studentId(newValue) {
      if (newValue) {
        this.onHandlerSearch();
        this.initFilters();
      }
    },
  },
  mounted() {
    this.initFilters();
    this.onHandlerSearch();
  },
  methods: {
    async initFilters() {
      const { data } = await getRecordEvaluationFilterOptions(this.studentId);
      this.model.search.collections.academicYears = data.academicYears;
      this.model.search.collections.types = data.evaluationTypes;
    },
    async getDisciplines(serviceType) {
      const { id } = serviceType || {};
      if (!id) {
        this.model.search.collections.therapies = [];
        return;
      }
      const data = await getAllDisciplineTypes({
        serviceTypeIds: [id],
      });
      this.model.search.collections.therapies = data;
    },
    async onHandlerSearch() {
      if (!this.studentId) return;

      const payload = {
        disciplineId: this.model.search.filters.therapy?.id,
        academicYearId: this.model.search.filters.academicYear?.id,
        evaluationTypeId: this.model.search.filters.type?.id,
      };

      const { data: results } = await getRecordEvaluation(
        this.studentId,
        payload
      );
      this.model.disciplines = results.map((x) => ({
        ...x,
        items: x.items.map((y) => ({
          ...y,
          opened: false,
        })),
        opened: false,
      }));
    },
    async open(item, key) {
      this.model.disciplines
        .filter((x, i) => i !== key)
        .forEach((x) => (x.opened = false));
      setTimeout(() => (item.opened = !item.opened), 100);
    },
    async openDoc(doc, disciplineIdx, itemIdx) {
      this.model.disciplines[disciplineIdx].items
        .filter((x, i) => i !== itemIdx)
        .forEach((x) => (x.opened = false));
      if (!doc.opened) {
        this.getDetail(doc.clientAppointmentId);
      }
      doc.opened = !doc.opened;
    },
    download(item) {
      const { documentId, documentAttachmentId } = item;
      const id = documentId || documentAttachmentId;
      DocumentsService.downloadDocumentByAttachmentId(id);
    },
    async getDetail(id) {
      if (!id) return;
      const { data } = await getRecordEvaluationDetail(id);
      this.model.detail = data;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .icon-view-extended {
    margin-bottom: 0.5rem;
    .dot {
      margin-right: 0.5rem !important;
      width: 40px !important;
      height: 40px !important;
      .title-icon {
        margin: 0 !important;
      }
    }
    .font-16.color-gray-7 {
      font-size: 24px !important;
    }
  }
}

.callout-extended ::v-deep .col.p-2 > .col-12 {
  border-left: 1px solid #e2e2e2;
}
</style>
